import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { IS_PRODUCTION } from "./variables/config"

export const initI18n = (lng) => {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: lng ?? window.APP_LOCALE,
      fallbackLng: false,
      backend: {
        loadPath: (lngs) => `${window.__AVIA_ORIGIN__ || ""}/api/translations?locale=${lngs[0]}`,
        requestOptions: {
          cache: "default",
          credentials: window.__AVIA_ORIGIN__ ? "omit" : "include",
        },
      },
      load: "currentOnly",
      supportedLngs: ["ro", "ru", "uk", "en", "fr", "bg"],
      detection: {
        order: ["navigator"],
        caches: [],
      },
      debug: !IS_PRODUCTION,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
    })

  window.i18n = i18n
  window.dispatchEvent(new Event("i18n:ready"))
}

// На вашем сайте инициализируем сразу, в виджете это делает mount()
if (!window.i18n && !window.__AVIA_EMBED__) {
  initI18n()
}

export default i18n
